/** Rows loaded per scroll on listing pages. */
export const LIST_PAGE_SIZE = 10;

export function mergeLoadedPageRowKey(row) {
  if (!row || typeof row !== 'object') return '';
  const key = row.shipment_id ?? row.id ?? row.uuid ?? row._id;
  return key == null ? '' : String(key);
}

function dedupeLoadedRows(rows, freshByKey = null) {
  const seen = new Set();
  const out = [];
  for (const row of rows) {
    const key = mergeLoadedPageRowKey(row);
    if (!key || seen.has(key)) continue;
    seen.add(key);
    out.push(freshByKey?.get(key) || row);
  }
  return out;
}

/**
 * Replace the list on page 1. Later pages replace their slice (append when not loaded yet).
 * De-duplicates by row id so scroll / refresh cannot stack the same shipment twice.
 */
export function mergeLoadedPage(page, incoming, previous, pageSize = LIST_PAGE_SIZE) {
  const rows = Array.isArray(incoming) ? incoming : [];
  const pageNum = Number(page) || 1;
  if (pageNum <= 1) return dedupeLoadedRows(rows);

  const prev = Array.isArray(previous) ? previous : [];
  if (!rows.length) return prev;

  const size = Number(pageSize) || LIST_PAGE_SIZE;
  const start = (pageNum - 1) * size;
  const base =
    prev.length > start
      ? prev.slice(0, start).concat(rows, prev.slice(start + size))
      : prev.concat(rows);

  const freshByKey = new Map(
    rows.map((row) => [mergeLoadedPageRowKey(row), row]).filter(([key]) => key),
  );
  return dedupeLoadedRows(base, freshByKey);
}
